'use strict';

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * This is a simple wrapper to unify EventEmitter implementations across platforms.
 */

module.exports = require('events').EventEmitter;
var EventEmitter;


//////////////////
// WEBPACK FOOTER
// ./~/parse/lib/browser/EventEmitter.js
// module id = 440
// module chunks = 0